import React, { useEffect, useRef, useState } from 'react';
import { getImages } from '../const';
import { Link } from 'react-router-dom';

const ActionButtons = ({ openDropdown, wrapperRef, toggleDropdown }) => {
    return (
        <div className='actions-btns ms-sm-4 ms-0 d-flex align-items-center' ref={wrapperRef}>
            {/* Search Button */}
            <div className={openDropdown === 'search' ? 'active' : ''}>
                <button type='button' className='transparent-btn hd-ab-btn' onClick={() => toggleDropdown('search')}>
                    <img src={getImages('hd-search-icon.png')} alt="Search" />
                </button>
            </div>

            {/* Phone Button */}
            <div className={openDropdown === 'phone' ? 'active' : ''}>
                <button type='button' className='transparent-btn hd-ab-btn' onClick={() => toggleDropdown('phone')}>
                    <img src={getImages('hd-phone-icon.png')} alt="Phone" />
                </button>
                {openDropdown === 'phone' && (
                    <div className='actions-dropdown'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='xs-title'>
                                    <div className='row mb-3'>
                                        <div className='col-5 opacity-0-5'>Sales</div>
                                        <div className='col-7 fw-bold text-end'>407-988-0111</div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-5 opacity-0-5'>Service</div>
                                        <div className='col-7 fw-bold text-end'>407-988-2545</div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-5 opacity-0-5'>Parts</div>
                                        <div className='col-7 fw-bold text-end'>407-988-2586</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Clock Button */}
            <div className={openDropdown === 'clock' ? 'active' : ''}>
                <button type='button' className='transparent-btn hd-ab-btn' onClick={() => toggleDropdown('clock')}>
                    <img src={getImages('hd-clock-icon.png')} alt="Clock" />
                </button>
                {openDropdown === 'clock' && (
                    <div className='actions-dropdown act-search-dropdown'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='xs-title text-orange text-uppercase mb-4'>Store Hours</div>
                                <div className='mnw-300 xs-title'>
                                    <div className='row mb-2'>
                                        <div className='col-6 opacity-0-5'>Monday - Friday</div>
                                        <div className='col-6 fw-bold'>9am - 6pm</div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-6 opacity-0-5'>Saturday</div>
                                        <div className='col-6 fw-bold'>10am - 4pm</div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-6 opacity-0-5'>Sunday</div>
                                        <div className='col-6 fw-bold'>Closed</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='xs-title text-orange text-uppercase mb-4'>Service Hours</div>
                                <div className='mnw-300 xs-title'>
                                    <div className='row mb-2'>
                                        <div className='col-6 opacity-0-5'>Monday - Friday</div>
                                        <div className='col-6 fw-bold'>8am - 5pm</div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-6 opacity-0-5'>Saturday</div>
                                        <div className='col-6 fw-bold'>Closed</div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-6 opacity-0-5'>Sunday</div>
                                        <div className='col-6 fw-bold'>Closed</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Location Button */}
            <div className={openDropdown === 'location' ? 'active' : ''}>
                <Link to="/contact" className='transparent-btn hd-ab-btn d-inline-block' onClick={() => toggleDropdown('location')}>
                    <img src={getImages('hd-location-icon.png')} alt="Location" />
                </Link>
                {/* {openDropdown === 'location' && (
                    <div className='actions-dropdown'>
                        Location content
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default ActionButtons;
